import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = () => {
  const testimonial = {
    quote: "PenGame PR Hub has revolutionized how we manage our author campaigns. The AI-powered content creation saves us hours every week, and the media contact management is exceptional.",
    author: "Sarah Mitchell",
    title: "Marketing Director",
    company: "Stellar Publishing House",
    avatar: "https://images.unsplash.com/photo-1702089050621-62646a2b748f",
    avatarAlt: "Professional headshot of woman with shoulder-length brown hair wearing navy blazer"
  };

  return (
    <div className="w-full max-w-md mx-auto mt-8">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-start space-x-1 mb-4">
          {[...Array(5)]?.map((_, i) =>
          <Icon key={i} name="Star" size={16} className="text-warning fill-current" />
          )}
        </div>
        
        <blockquote className="text-sm text-muted-foreground mb-4 leading-relaxed">
          "{testimonial?.quote}"
        </blockquote>
        
        <div className="flex items-center space-x-3">
          <Image
            src={testimonial?.avatar}
            alt={testimonial?.avatarAlt}
            className="w-10 h-10 rounded-full object-cover" />

          <div>
            <p className="text-sm font-medium text-foreground">
              {testimonial?.author}
            </p>
            <p className="text-xs text-muted-foreground">
              {testimonial?.title}, {testimonial?.company}
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TestimonialCard;